<div *ngIf="errors$ | async as errors" class="errors-container">
    <div *ngIf="errors.length">
        <div *ngIf="showError$ | async as showError">
            <ul class="errors-list">
                <li
                    *ngFor="let item of errors"
                    [ngClass]="itemClass(item)"
                    role="menuitem"
                    style="padding: 0.25rem 1rem;"
                    data-id="{{ item.MsgEntityID }}"
                    (click)="selectError(item)"
                >
                    <ng-template #highlight>
                        <div style="display: flex;">
                            <i class="pi pi-angle-right text-primary" style="align-self: center;"></i>
                            <p-message
                                class="highlight"
                                *ngIf="item.StatusCode == 2"
                                severity="warn"
                                [text]="item.Message"
                            ></p-message>
                            <p-message
                                class="highlight"
                                *ngIf="item.StatusCode == 3"
                                severity="error"
                                [text]="item.Message"
                            ></p-message>
                        </div>
                    </ng-template>
                    <ng-template #global>
                        <p-message
                            *ngIf="item.StatusCode == 2"
                            severity="warn"
                            [text]="item.Message"
                        ></p-message>
                        <p-message
                            *ngIf="item.StatusCode == 3"
                            severity="error"
                            [text]="item.Message"
                        ></p-message>
                    </ng-template>
                    <div
                        *ngIf="
                            showError?.MsgEntityID?.toString() ===
                                item?.MsgEntityID?.toString();
                            then highlight;
                            else global
                        "
                    ></div>
                </li>
            </ul>
        </div>
    </div>
</div>

